module.exports = __webpack_public_path__ + "img/img24.190b9e11.png";